<template>
  <div>
    <v-dialog v-model="dialogFormularioReserva" :width="dialogWidth" persistent>
      <reserva-formulario :modelReserva="this.modelReserva" :accion="this.accion"
        @cerrarFormularioReserva="_actualizarDatos" @cerrar="dialogFormularioReserva = false"
        @actualizar="_actualizar" />
    </v-dialog>
    <v-navigation-drawer :dark="true" class="mt-0" :color="colorNavigationMenu" app permanent>
      <v-divider></v-divider>
      <v-list-item class="my-4">
        <v-img src="../assets/logo5.png" height="100px" contain></v-img>
      </v-list-item>

      <v-divider></v-divider>



      <v-list dense nav>
        <v-list-item-group :color="'white'">
          <v-row class="mb-1">
            <v-col cols="12">
              <v-container
                :style="{ backgroundColor: '#666666', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                <span style="color: white;">GESTIÓN</span>
              </v-container>
            </v-col>
          </v-row>

          <v-list-item v-for="item in menusGestion" :key="item.title" link @click="_redireccionar(item.link)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            
          </v-list-item>

          <v-row class="mt-1 mb-1">
            <v-col cols="12">
              <v-container
                :style="{ backgroundColor: '#666666', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                <span style="color: white;">CATÁLOGOS</span>
              </v-container>
            </v-col>
          </v-row>

          <v-list-item v-for="item in menusCatalogos" :key="item.title" link @click="_redireccionar(item.link)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-row v-if="_tienePermisoAdministracion()" class="mt-1 mb-1">
            <v-col cols="12">
              <v-container
                :style="{ backgroundColor: '#666666', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                <span style="color: white;">ADMINISTRACIÓN</span>
              </v-container>
            </v-col>
          </v-row>


          <v-list-item v-if="_tienePermisoAdministracion()" v-for="item in menusAdministracion" :key="item.title" link @click="_redireccionar(item.link)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


          <v-row class="mt-1 mb-1">
            <v-col cols="12">
              <v-container
                :style="{ backgroundColor: '#666666', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                <span style="color: white;">CONFIGURACIÓN</span>
              </v-container>
            </v-col>
          </v-row>


          <v-list-item v-for="item in menusConfiguracion" :key="item.title" link @click="_redireccionar(item.link)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-item-group>
      </v-list>

      <!--
      <v-col class="ml-4 mt-4">
        <v-row class="mt-12 mb-2"> <span v-bind:style="{ color: '#B0BEC5' }">Leyenda de estados</span> </v-row>
        <v-row class="mb-2">
          <v-chip label small class="px-1 mr-1 ml-0" link :style="'border-bottom: 3px solid #FFFFFF'"
            :color="'#FFA500'">
            <h5 v-bind:style="{ color: 'white' }">01</h5>
          </v-chip>
          <span v-bind:style="{ color: '#B0BEC5', fontSize: '12px' }">Pendiente de respuesta</span>
        </v-row>

        <v-row class="mb-2">
          <v-chip label small class="px-1 mr-1 ml-0" link :style="'border-bottom: 4px solid #FFFFFF'"
            :color="'#006400'">
            <h5 v-bind:style="{ color: 'white' }">01</h5>
          </v-chip>
          <span v-bind:style="{ color: '#B0BEC5', fontSize: '12px' }">Completada sin cancelaciones</span>
        </v-row>

        <v-row class="mb-2">
          <v-chip label small class="px-1 mr-1 ml-0" link :style="'border-bottom: 4px solid #FFFFFF'"
            :color="'#EF5350'">
            <h5 v-bind:style="{ color: 'white' }">01</h5>
          </v-chip>
          <span v-bind:style="{ color: '#B0BEC5', fontSize: '12px' }">Cancelación total</span>
        </v-row>

        <v-row class="mb-2">
          <v-chip label small class="px-1 mr-1 ml-0" link :style="'border-bottom: 4px solid #EF5350'"
            :color="'#FFA500'">
            <h5 v-bind:style="{ color: 'white' }">01</h5>
          </v-chip>
          <span v-bind:style="{ color: '#B0BEC5', fontSize: '12px' }">Pendiente con cancelaciones</span>
        </v-row>


        <v-row class="mb-2">
          <v-chip label small class="px-1 mr-1 ml-0" link :style="'border-bottom: 4px solid #EF5350'"
            :color="'#006400'">
            <h5 v-bind:style="{ color: 'white' }">01</h5>
          </v-chip>
          <span v-bind:style="{ color: '#B0BEC5', fontSize: '12px' }">Completada con cancelaciones</span>
        </v-row>



      </v-col>-->
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ReservaFormulario from "./formularios/ReservaFormulario.vue";


export default {
  components: {
    ReservaFormulario
  },

  data: () => ({
    dialogFormularioReserva: false,
    modelReserva: null,
    accion: "crear",

    selectedItem: null,
    menusGestion: [
      {
        title: "Presupuestos",
        icon: "mdi-file-document-outline",
        link: "Presupuestos",
        desc: "Control de presupuestos",
      },

      {
        title: "Reservas",
        icon: "mdi-format-line-style",
        link: "Reservas",
        desc: "Control de reservas",
      },
      {
        title: "Clientes",
        icon: "mdi-face",
        link: "Clientes",
        desc: "Control de clientes",
      },

    ],

    menusCatalogos: [
      {
        title: "Caminos",
        icon: "mdi-hiking",
        link: "Caminos",
        desc: "",
      },
      {
        title: "Proveedores",
        icon: "mdi-home-city",
        link: "Proveedores",
        desc: "",
      },
      {
        title: "Alojamientos",
        icon: "mdi-home",
        link: "Alojamientos",
        desc: "",
      },
      {
        title: "Grupos y Agencias",
        icon: "mdi-water-well",
        link: "Agencias",
        desc: "",
      },

    ],

    menusAdministracion: [
      {
        title: "Cuentas",
        icon: "mdi-bank",
        link: "Cuentas",
        desc: "Gestionar cuentas",
      },
      {
        title: "Formas de Pago",
        icon: "mdi-cash-multiple",
        link: "FormasPago",
        desc: "Gestionar formas de pago",
      },
      
    ],

    menusConfiguracion: [
      {
        title: "Mi Perfil",
        icon: "mdi-account-circle",
        link: "MiPerfil",
        desc: "Mi perfil de usuario",
      },
      {
        title: "Empleados",
        icon: "mdi-account-group",
        link: "Empleados",
        desc: "Gestionar empleados",
      },
      {
        title: "Ayuda",
        icon: "mdi-help-circle",
        link: "Ayuda",
        desc: "",
      },
      {
        title: "Incidencias",
        icon: "mdi-alert-octagon",
        link: "Incidencias",
        desc: "Reportar incidencias",
      },
      {
        title: "Cerrar sesión",
        icon: "mdi-account-circle",
        link: "login",
        desc: "",
      },
    ],
  }),

  computed: {
    ...mapState("auth", ["user", "access_token"]),
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorFondoOscuro",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",

      "colorNavigationMenu",
      "colorBarraFormulario",
      "colorFondo500",
      "colorFondo400",
      "colorBotonRed",
      "colorBotonBlue",
    ]),
    ...mapState("estados", ["estados"]),
    ...mapState("reservas", [
      "dialogWidth",
      "from",
      "until"
    ]),
  },

  methods: {
    ...mapActions("auth", ["logOut"]),
    ...mapMutations(["setDark", "setDrawer"]),
    ...mapActions("reservas", ["getReservasCalendario"]),

    async _redireccionar(view) {
      if (view == "login") {
        this.setDrawer(false);
        await this.logOut([this.access_token]);
      }
      if (view != this.$router.currentRoute.name) {
        this.$router.push("/" + view);
      }
      //
    },

    _tieneAlojamientosCancelados() {
      let res = "#FFFFFF";

      return res;
    },


    _crearReserva() {
      /* this._inicializarModelReserva();
       this.accion = 'crear';
       this.dialogFormularioReserva = true;*/
    },

    _inicializarModelReserva() {
      this.modelReserva = {
        id: null,
        fecha_inicial: null,
        fecha_final: null,
        ubicacion_inicial: null,
        ubicacion_final: null,

        cant_dias: 0,
        cant_bicis: 0,
        cant_bicis_s: 0,
        cant_bicis_m: 0,
        cant_bicis_l: 0,
        cant_bicis_xl: 0,
        cant_bicis_ms: 0,
        cant_bicis_mm: 0,
        cant_bicis_ml: 0,

        precio: 0.00,
        precio_m: 0.00,
        importe: 0.00,
        fianza: 0.00,
        descuento: 0.00,
        total: 0.00,

        pagado: 0.00,
        pendiente: 0.00,

        transporte_km: 0,
        transporte_precio: 0.00,
        transporte_importe: 0.00,

        casco: false,
        alforjas: false,
        pedales_automaticos: false,
        gps: false,

        sin_iva: false,
        descuento_agencia: false,


        observaciones: null,
        estado: {
          id: null,
          nombre: null,
        },
        cliente: {
          id: null,
          tipoCliente: null,
          nombre: null,
          apellidos: null,
          telefono: null,
          email: null,
          documento: null,
          direccion: null,
          comentarios: null,
        },
        bicis: []
      };
    },

    _actualizarDatos() {
      this.dialogFormularioReserva = false;
      this._getReservasCalendario(true);
    },

    _actualizar() {
      this._getReservasCalendario(this.from, this.until, false);

    },

    _tienePermisoAdministracion() {
      console.log('user11:', this.user);
      return this.user != null && (this.user.rol == "ADMIN" || this.user.rol == "SUPERADMIN");
    },

    async _getReservasCalendario(loading) {
      if (loading) {
        this.showLoading = true;
      }
      await this.getReservasCalendario([
        this.access_token,
        this.from,
        this.until,
        loading,
      ]);
      this.showLoading = false;
    },
  },
};
</script>

<style></style>
